// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"Roles_saveButton__1WCO1","edit":"Roles_edit__2q275","ghostButton":"Roles_ghostButton__2LFko","closeIcon":"Roles_closeIcon__39mR-"};